angular
  .module('contrast.rules.exclusions', [
    'ngRoute',
    'ngAnimate',
    'route-segment',
    'view-segment',
    'xeditable',
    'ngSanitize'
  ])
  .controller(
    'EditExclusionCtrl',
    function ($scope, $routeParams, permissions) {
      'ngInject'

      angular.extend($scope, {
        appId: $routeParams.appId,
        exclusionId: $routeParams.exclusionId
      })

      //functions
      angular.extend($scope, {
        isRASPEnabled: isRASPEnabled
      })

      function isRASPEnabled() {
        return permissions.isRASPEnabled()
      }
    }
  )
